module.exports = __webpack_public_path__ + "static/media/Sharp-Memory-In-Pixel_700x1082.7928af8a.jpg";